import React from "react";
import { connect } from "react-redux";
import { Outlet, ScrollRestoration } from "react-router-dom";
import { ThemeContext } from "../../contexts/ThemeContext";

// Components
import AdminSideNavBar from "../../components/Navigation/AdminSideNavBar";
import AdminTopNavBar from "../../components/Navigation/AdminTopNavBar";

// Redux

// Services
import FlashMessage from "../../components/FlashMessage";
import ForceCompanySelection from "../../components/ForceCompanySelection";

const AdminWrapper = (props) => {
  return (
    <div className="theme-light">
      <ThemeContext.Provider value={{ theme: "light" }}>
        <AdminTopNavBar />
        <AdminSideNavBar />
        <FlashMessage />
        <div className="pt-20 print:pt-0 sm:pl-56 print:pl-0 absolute top-0 bottom-0 left-0 right-0">
          <ForceCompanySelection
            currentCompanyId={props.currentUser.currentCompanyId}
            currentUser={props.currentUser}
          >
            <Outlet />
          </ForceCompanySelection>
        </div>
      </ThemeContext.Provider>
      <ScrollRestoration />
    </div>
  );
};

const mapStateToProps = (state) => {
  const { metadata, currentUser } = state;
  return { metadata, currentUser };
};

export default connect(mapStateToProps)(AdminWrapper);
